import type { PermissionSource } from './route-gate';

/**
 * Permissions a gate answers to that NO contract leaf declares: the backend enforces
 * them inside a handler or a middleware, or they exist only to show a screen.
 * A literal belongs here only while no route declares it — the test beside this file
 * fails the moment one does, and the gate must then name that route instead.
 */
export const nonRouteRules = {
  // Enforced in the activity delete handler: deleting another member's e-mail activity.
  deleteOthersEmailActivity: { permission: 'organization:activity:activity-delete' },
  // Enforced by `deal-oversight.middleware.ts`, not by a leaf: the Standortleitung's cross-deal view.
  dealOversight: { permission: 'organization:deal:deal-oversight' },
  // A screen grant: holding it unhides the workspace Members page (see the comment in
  // `static-org-role-catalogue.ts`). The list route itself declares `workspace:identity:member-read`.
  membersScreen: { permission: 'organization:identity:member-read' },
  // The HLRE area's entry: held by every HLRE role, declared by no route yet (the area pages arrive with IMM-1443).
  hlreArea: { permission: 'workspace:hlre:area-read' },
} as const satisfies Record<string, PermissionSource>;
